export enum CustomHttpStatusCode {
  UnknownError = 0
}
